import AbstractManageable           from './abstract-manageable'
import Instruction                  from './instruction'
import Observation                  from './observation'
import Loan                         from './loan'
import User                         from './user'
import LocalAuthorityChapterAccount from './local-authority-chapter-account'
import Result                       from './result'
import Rest                         from './rest'
import Demography                   from "./demography"
import BergerLevrault               from "./berger-levrault"

export default class LocalAuthority extends AbstractManageable {

	/**
	 *
	 * @param {Number}                         id
	 * @param {String}                         name
	 * @param {String}                         code
	 * @param {String}                         slug
	 * @param {BergerLevrault}                 bergerLevrault
	 * @param {Instruction}                    instruction
	 * @param {LocalAuthorityChapterAccount[]} accounts
	 * @param {Observation[]}                  observations
	 * @param {Loan[]}                         loans
	 * @param {Result[]}                       results
	 * @param {Rest[]}                         rests
	 * @param {Demography[]}                   demographies
	 * @param {User}                           creator
	 * @param {Date}                           createdAt
	 * @param {User}                           updater
	 * @param {Date}                           updatedAt
	 * @param {Date}                           lastImportDate
	 */
	constructor(
			id,
			name,
			code,
			slug,
			bergerLevrault,
			instruction,
			accounts,
			observations,
			loans,
			results,
			rests,
			demographies,
			creator,
			createdAt,
			updater,
			updatedAt) {
		super(creator, createdAt, updater, updatedAt)

		this.accounts       = accounts || []
		this.code           = code
		this.id             = id
		this.bergerLevrault = bergerLevrault
		this.instruction    = instruction
		this.observations   = observations || []
		this.loans          = loans || []
		this.results        = results || []
		this.rests          = rests || []
		this.demographies   = demographies || []
		this.name           = name
		this.slug           = slug
	}

	static createFromJson = (json) => {
		if (!json) return null

		return new LocalAuthority(
			json.id,
			json.name,
			json.code,
			json.slug,
			BergerLevrault.createFromJson(json.bergerLevrault),
			Instruction.createFromJson(json.instruction),
			json.accounts && json.accounts.map(j => LocalAuthorityChapterAccount.createFromJson(j)),
			json.observations && json.observations.map(j => Observation.createFromJson(j)),
			json.loans && json.loans.map(j => Loan.createFromJson(j)),
			json.results && json.results.map(j => Result.createFromJson(j)),
			json.rests && json.rests.map(j => Rest.createFromJson(j)),
			json.demographies && json.demographies.map(j => {
				let demography = Demography.createFromJson(j)
				demography.localAuthority = this
				return demography
			}),
			User.createFromJson(json.creator),
			new Date(json.createdAt),
			User.createFromJson(json.updater),
			new Date(json.updatedAt),
			new Date(json.lastImportDate)
		)
	}
}


// WEBPACK FOOTER //
// ./src/model/local-authority.js